import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { ProductCategoryService } from '../rest_services/family.service';
import { SalesService } from '../rest_services/sales.service';
import { CustomersService } from '../rest_services/customers.service';
import { VisitService } from '../rest_services/visit.service';
import { Subscription } from 'rxjs';
import { Referential } from '../models/referential';
import { ServiceResponse } from '../models/service-response';
import { ActivatedRoute, Route, Router } from '@angular/router';

@Component({
  selector: 'app-sales-commercial',
  templateUrl: './sales-commercial.component.html',
  styleUrls: ['./sales-commercial.component.css']
})
export class SalesCommercialComponent implements OnInit {

  
    advancedSearchForm: FormGroup;
    loading_sales:boolean = true;
    role:any;
    mobile:boolean=false;
    commercial:any=null;
  
    constructor(private productCategoryService:ProductCategoryService,
      private fb:FormBuilder, private salesService:SalesService, 
      private customersService:CustomersService,
      private visitService:VisitService, private route:ActivatedRoute
    ) {
      this.advancedSearchForm = this.fb.group({
          'commercial':[''],
          'start_date':[''],
          'end_date':['']
        },{ validators: this.dateValidator }); 
        this.getCommercials();
     }
  
     dateValidator(group: AbstractControl): ValidationErrors | null {
      const start = group.get('start_date')?.value;
      const end = group.get('end_date')?.value;
      
      if (end && !start) return { startRequired: true };
      if (start && end && end < start) return { dateInvalid: true };
      return null;
    }
    initDates(): void {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      
      this.advancedSearchForm.patchValue({
        commercial:this.commercial,
        start_date: this.formatDate(firstDay),
        end_date: this.formatDate(lastDay)
      });
      const localStart = new Date(firstDay.getTime() - firstDay.getTimezoneOffset() * 60000);
      var dateStart = localStart.toISOString().slice(0, 16);
      const localEnd = new Date(lastDay.getTime() - lastDay.getTimezoneOffset() * 60000);
      var dateEnd = localEnd.toISOString().slice(0, 16);
      this.advancedSearchForm.controls["start_date"].setValue(dateStart);
      this.advancedSearchForm.controls["end_date"].setValue(dateEnd);
    }
    formatDate(date: Date): string {
      return date.toISOString().split('T')[0]; // Format YYYY-MM-DD
    }
    ngOnInit(): void {
      this.initDates();
      this.commercial= this.route.snapshot.paramMap.get('cr')
      if(localStorage.getItem("role")!=undefined) {
        this.role =localStorage.getItem("role");
      }else if(sessionStorage.getItem("role")!=undefined){
        this.role =sessionStorage.getItem("role");
      }
      if (window.screen.width < 768) { // 768px portrait
        this.mobile = true;
      }else {
        this.mobile = false;
      }
      this.search();
    }
    
    salesData:any[]=[];
    salesDataFiltred:any[]= [];
    salesSubscription!: Subscription;
    loading_actions_search:boolean=false;
    areAllControlsEmpty(): boolean {
      const controls = this.advancedSearchForm.controls;   
      return Object.keys(controls).every(controlName => controls[controlName].value === '');
    }
  
    onKeyUp(event:any,input:any) { // appending the updated value to the variable    
      if(event.target.value.length==0) {
        this.advancedSearchForm.controls[input].setValue("");
      }
    }
  
    isValidUUID(uuid: string): boolean {
      const uuidPattern = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
      return uuidPattern.test(uuid);
    }
    advancedSearchRequest:any={};
    loading_sales_search:boolean=false;
    search(){
      ($('.collapse.show')as any).collapse('hide');
      let customerUUID = this.commercial;
      this.advancedSearchForm.controls['commercial'].setValue(customerUUID);
       this.salesService.advancedSearchRequest = this.advancedSearchForm.value;    
      if(this.advancedSearchForm.value.customer==""&&
        (this.advancedSearchForm.value.start_date=="" || this.advancedSearchForm.value.end_date=="" )
        ){
        // this.getSales();
      }else {            
        this.loading_sales_search = true;
        this.salesService.advancedSearchSales();
        this.advancedSearchRequest=this.salesService.advancedSearchSubject.subscribe(
          ( data: any ) => {
            this.loading_sales_search = false;
            if(data.code=="6525898e10b22b1606604de6218b26a2"){
              this.salesDataFiltred = data.sales;
              (<any>$('#alter_paginations')).DataTable().clear().destroy();
              setTimeout(()=>{
                const tableElement = $("#alter_paginations");
                const hasData = tableElement.find('tbody tr').length > 0
                                && tableElement.find('tbody tr td.dataTables_empty').length === 0;
                (<any>$("#alter_paginations")).DataTable({
                  "pagingType": "full_numbers",
                  "scrollX": '400px',
                  "aaSorting": [],
                  "iDisplayLength": 25,
                  dom: 'Blfrtip',
                  columnDefs: [{ type: 'date', 'targets': [4], "orderable": true }],
                  "scrollCollapse": false,
                  buttons: {
                    buttons: [
                      {
                        extend: 'copy', className: 'btn btn-default btn-rounded btn-sm mb-4',
                        footer: true,
                        action: function () {
                          var table = (<any>$("#alter_pagination")).DataTable();
                          var tableData = table.buttons.exportData().body;
                          var textData = '';
                          tableData.forEach((row: any) => {
                            textData += row.join('\t') + '\n';
                          });
                          const dummyTextarea = document.createElement('textarea');
                          dummyTextarea.textContent = textData;
                          document.body.appendChild(dummyTextarea);
                          dummyTextarea.select();
                          document.execCommand('copy');
                          document.body.removeChild(dummyTextarea);

                          $("#copyMessage").addClass("show");
                          setTimeout(() => {
                            $("#copyMessage").removeClass("show");
                          }, 2000);
                        }
                      },
                      { extend: 'excel', className: 'btn btn-default btn-rounded btn-sm mb-4', footer: true },
                      { extend: 'print', className: 'btn btn-default btn-rounded btn-sm mb-4',footer: true }
                    ]
                  },
                  initComplete: function () {
                    const api = this.api();
                    const btnContainer = $(api.table().container()).find('.dt-buttons');
                    api.data().count() === 0 ? btnContainer.hide() : btnContainer.show();
                  },
                  footerCallback: function (row: any, data: any, start: any, end: any, display: any) {
                    const api = this.api();

                    const parseNumber = (val: any): number => {                      
                      if (typeof val === 'string') {
                        // Supprime tout sauf chiffres, virgule et point
                        val = val.replace(/\s/g, '').replace(',', '.');
                      }
                      const num = parseFloat(val);
                      
                      return isNaN(num) ? 0 : num;
                    };
                    const formatNumber = (val: number): string => {
                      return val.toLocaleString('fr-FR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
                    };

                    // Total HT = colonne index 6
                    const totalHT = api
                      .column(6, { page: 'current' })
                      .data()
                      .reduce((a: number, b: any) => a + parseNumber(b), 0);

                    // Total TTC = colonne index 8
                    const totalTTC = api
                      .column(8, { page: 'current' })
                      .data()
                      .reduce((a: number, b: any) => a + parseNumber(b), 0);

                    $(api.column(6).footer()).html('<b>' + formatNumber(totalHT) + ' MAD</b>');
                    $(api.column(8).footer()).html('<b>' + formatNumber(totalTTC) + ' MAD</b>');
                  },
                  "language": {
                    "sProcessing": "Traitement en cours ...",
                    "sLengthMenu": "Afficher _MENU_ lignes",
                    "sZeroRecords": "Aucun résultat trouvé",
                    "sEmptyTable": "Aucune donnée disponible",
                    "sInfo": "",
                    "sInfoEmpty": "",
                    searchPlaceholder: "Saisir un mot clé",
                    "sInfoFiltered": "",
                    "sInfoPostFix": "",
                    "sSearch": "Rechercher:",
                    "sUrl": "",
                    "sInfoThousands": ",",
                    "sLoadingRecords": "Chargement...",
                    "oPaginate": {
                      "sFirst": "<i class='flaticon-left-arrow'></i>",
                      "sLast": "<i class='flaticon-right-arrow'></i>",
                      "sNext": "<i class='flaticon-arrow-right'></i>",
                      "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                    },
                    "oAria": {
                      "sSortAscending": ": Trier par ordre croissant",
                      "sSortDescending": ": Trier par ordre décroissant"
                    }
                  },
                  drawCallback: function () {
                    const api = this.api();
                    const btnContainer = $(api.table().container()).find('.dt-buttons');
                    api.data().count() === 0 ? btnContainer.hide() : btnContainer.show();

                    (<any>$('.sparkline')).sparkline([5, 6, 7, 9, 9, 5, 3, 2, 2, 4, 6, 7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                    });
                  }
                });
              }, 500);
            }
          },
        )
      }
    }
  
    commercialFullname:any="- - -";
    ourTeam:any[]=[]
    getCommercials(){
      var glob=this;
      this.visitService.getCommercialsToAffect();
      this.visitService.commercialsSubject.subscribe(
        ( data: any ) => {
          if(data.code=="b1f37eec383fcada527079602ac178b3"){          
            this.ourTeam = data.commercials;            
            var commercial = this.ourTeam.find(member => member.commercial_uuid && member.commercial_uuid.toUpperCase().includes(this.commercial.toUpperCase()));   
            this.commercialFullname = commercial?.commercial;
          }
        },
      )  
    }

}
